export const formatPercentage = (value: number | null | undefined) =>
  value !== null && value !== undefined ? `${value}%` : ""
